import { ChangeEvent, useState } from "react";
import Container from "../components/Container";
import { CssTextField } from "./user/UserProfile";
import { MenuItem, TextField } from "@mui/material";
import Button from "../components/Button";
import { JobreadyContract } from "../web3/integrate";


const TutorRegister = () => {
  const [tutorDetails, setTutorDetails] = useState({
    occupation: "",
    field: "",
    experience: "",
    years: "",
    rating: "",
  });

  // const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
  //   const { name, value } = e.target;
  //   setTutorDetails((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  const handleChange = (e: ChangeEvent<HTMLInputElement | { name: string; value: unknown }>) => {
    const { name, value } = e.target;
  
    if (name === "field" || name === "experience" || name === "years") {
      setTutorDetails((prev) => ({
        ...prev,
        [name]: value as string,
      }));
    } else {
      setTutorDetails((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  

  async function tutorRegistration() {
    try {
      // Estimate the gas required to execute the transaction
      const gasLimit = await JobreadyContract.estimateGas.tutorRegistration(
        fields, experience, years,
        );
  
      // Create the transaction object
      const tx = await JobreadyContract.tutorRegistration(
        fields, experience, years,
         {
        gasLimit,
      });
      const receipt = await tx.wait();
      console.log("Transaction mined. Transaction hash:", receipt.transactionHash);
      console.log("Transaction status:", receipt.status); // 1 indicates success
      console.log("Event logs:", receipt.logs);
    } catch (error) {
      console.error("Error creating profile:", error);
    }
  
  }

  const fields = [
    {
      value: "Product Design",
      label: "Product Design",
    },
    {
      value: "Software Development",
      label: "Software Development",
    },
    {
      value: "Product Management",
      label: "Product Management",
    },
    {
      value: "Data Analysis",
      label: "Data Analysis",
    },
    {
      value: "CyberSecurity Engineering",
      label: "CyberSecurity Engineering",
    },
    {
      value: "3D Animation and Mixed Reality",
      label: "3D Animation and Mixed Reality",
    },
    {
      value: "Blockchain Engineering",
      label: "Blockchain Engineering",
    },
    {
      value: "Web Design and Development",
      label: "Web Design and Development",
    },
  ];

  const experience = [
    {
      value: "Beginner",
      label: "Beginner",
    },
    {
      value: "Intermediate",
      label: "Intermediate",
    },
    {
      value: "Expert",
      label: "Expert",
    },
  ];

  const years = [
    {
      value: "0",
      label: "Newbie",
    },
    {
      value: "1",
      label: "1+",
    },
    {
      value: "2",
      label: "2+",
    },
    {
      value: "3",
      label: "3+",
    },
  ];
  return (
    <Container>
      <div className="bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] h-[80vh] mt-20 p-5 flex flex-col items-center justify-between pb-10">
        <p className="text-main-blue">
          Hi Chinonye, welcome to Job Ready tutoring.
        </p>
        <div className="w-[40%]">
          <CssTextField
            id="occupation"
            label="Occupation"
            name="occupation"
            margin="normal"
            size="small"
            value={tutorDetails.occupation}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            select
            fullWidth
            id="field"
            name="field"
            label="What field will you be tutoring in?"
            size="small"
            margin="normal"
            value={tutorDetails.field}
            onChange={handleChange}
          >
            {fields.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            fullWidth
            id="experience"
            name="experience"
            label="What would you say is your experience level right now?"
            size="small"
            margin="normal"
            value={tutorDetails.experience}
            onChange={handleChange}
          >
            {experience.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            fullWidth
            id="years"
            name="years"
            label="How long have you been in this field"
            size="small"
            margin="normal"
            value={tutorDetails.years}
            onChange={handleChange}
          >
            {years.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div className="w-[30%] text-center">
          <Button onClick={tutorRegistration}>Register</Button>
        </div>
        <p className="text-[13px] ">
          Become a tutor today and have your contents visible to thousands of
          people
        </p>
      </div>
    </Container>
  );
};

export default TutorRegister;
